/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { IBreadcrumbViewProps } from '@msdyn365-commerce-modules/breadcrumb/src/modules/breadcrumb/./breadcrumb';

const BreadCrumbView: React.FC<IBreadcrumbViewProps> = props => {
	const { root, links, backButton, BreadcrumbContainer, BreadcrumbList, BreadcrumbListItem, separator } = props;
	if (!root && !links && !backButton) {
		props.context.telemetry.error('BreadCrumb content is empty, module wont render');
		return null;
	}
	return (
		<Module {...BreadcrumbContainer}>
			<Node {...BreadcrumbList}>
				{root && (
					<Node {...BreadcrumbListItem}>
						{root}
						{links && separator}
					</Node>
				)}
				{backButton && <Node {...BreadcrumbListItem}>{backButton}</Node>}
				{links && links.map((link, index) => {
					if(link && typeof link === "object" && ('props' in link)){
						return <React.Fragment key={index}>
							<Node
								{...BreadcrumbListItem}
								className={classnames(
									BreadcrumbListItem.className,
									index === links.length - 1 ? 'breadcrumb_item-current' : ''
								)}
							>
								<a href={'/'+ (link && link?.props.href.substring(1).split('/').slice(1).join('/'))} aria-label={(link && link.props.ariaLabel)}>
									{(link && link.props.text)}
								</a>
								{links[index + 2] && separator}	 {/*THIS IS TERRIBLE!!, should be +1*/}
							</Node>
						</React.Fragment>
					}
					return ''
				})}
			</Node>
		</Module>
	);
};

export default BreadCrumbView;
